<!-- Breadcrumb Section Start -->
<section class="breadcrumb-section pt-0">
    <div class="container-fluid-lg">
        <div class="row">
            <div class="col-12">
                <div class="breadcrumb-contain">
                    <!-- <h2>Contact Us</h2> -->
                    <li class="breadcrumb-item">
                        <a routerLink="/" routerLinkActive="router-link-active">
                            <i class="fa-solid fa-house"></i>
                        </a>
                    </li>
                    <li class="breadcrumb-item active">Contact Us</li>
                    <nav>
                        <ol class="breadcrumb mb-0">

                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Breadcrumb Section End -->

<!-- Contact Box Section Start -->
<section class="contact-box-section">
    <div class="container-fluid-lg">
        <div class="row g-lg-5 g-3">
            <div class="col-lg-6 padBottom">
                <div class="left-sidebar-box">
                    <div class="row">
                        <div class="col-xl-12">
                            <div class="contact-image">
                                <img src="assets/images/contact-us.png" class="img-fluid blur-up lazyloaded" alt="">
                            </div>
                        </div>
                        <div class="col-xl-12">
                            <div class="contact-title">
                                <h3>Get In Touch</h3>
                            </div>

                            <div class="contact-detail">
                                <div class="row g-4">
                                    <div class="col-xxl-6 col-lg-12 col-sm-6">
                                        <div class="contact-detail-box">
                                            <div class="contact-icon">
                                                <i class="fa-solid fa-phone"></i>
                                            </div>
                                            <div class="contact-detail-title">
                                                <h4>Phone</h4>
                                            </div>

                                            <div class="contact-detail-contain">
                                                <p>{{ DataList.contact_number || "-" }}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-xxl-6 col-lg-12 col-sm-6">
                                        <div class="contact-detail-box">
                                            <div class="contact-icon">
                                                <i class="fa-solid fa-envelope"></i>
                                            </div>
                                            <div class="contact-detail-title">
                                                <h4>Email</h4>
                                            </div>

                                            <div class="contact-detail-contain">
                                                <p>{{ DataList.email || '-'}}"</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-xxl-6 col-lg-12 col-sm-6">
                                        <div class="contact-detail-box">
                                            <div class="contact-icon">
                                                <i class="fa-solid fa-location-dot"></i>
                                            </div>
                                            <div class="contact-detail-title">
                                                <h4> Office</h4>
                                            </div>

                                            <div class="contact-detail-contain">
                                                <p>{{ DataList.address || "-" }}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- <div class="col-xxl-6 col-lg-12 col-sm-6">
                                        <div class="contact-detail-box">
                                            <div class="contact-icon">
                                                <i class="fa-solid fa-building"></i>
                                            </div>
                                            <div class="contact-detail-title">
                                                <h4>Bournemouth Office</h4>
                                            </div>

                                            <div class="contact-detail-contain">
                                                <p>Visitación de la Encina 22</p>
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="title d-xxl-none d-block">
                    <h2>Contact Us</h2>
                </div>
                <div class="right-sidebar-box">
                    <form [formGroup]="contactUs" class="row g-4">
                        <div class="row">
                            <div class="col-xxl-6 col-lg-12 col-sm-6">
                                <div class="mb-md-4 mb-3 custom-form">
                                    <label for="exampleFormControlInput" class="form-label">First Name</label>
                                    <div class="custom-input">
                                        <input type="text" class="form-control" formControlName="full_name" id="exampleFormControlInput" placeholder="Enter First Name">
                                        <i class="fa-solid fa-user"></i>
                                        <div *ngIf="f['full_name']?.invalid && (f['full_name']?.dirty || f['full_name']?.touched)" class="text-danger">
                                            <small *ngIf="f['full_name']?.errors?.['required']">
                        Full name is required.
                      </small>
                                            <small *ngIf="f['full_name']?.errors?.['pattern']">
                        Please enter valid full name.
                      </small>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="col-xxl-6 col-lg-12 col-sm-6">
                                <div class="mb-md-4 mb-3 custom-form">
                                    <label for="exampleFormControlInput1" class="form-label">Last Name</label>
                                    <div class="custom-input">
                                        <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="Enter Last Name">
                                        <i class="fa-solid fa-user"></i>
                                    </div>
                                </div>
                            </div> -->

                            <div class="col-xxl-6 col-lg-12 col-sm-6">
                                <div class="mb-md-4 mb-3 custom-form">
                                    <label for="exampleFormControlInput2" class="form-label">Email Address</label>
                                    <div class="custom-input">
                                        <input type="email" formControlName="email" class="form-control" id="exampleFormControlInput2" placeholder="Enter Email Address">
                                        <i class="fa-solid fa-envelope"></i>
                                        <div *ngIf="f['email']?.invalid && (f['email']?.dirty || f['email']?.touched)" class="text-danger">
                                            <small *ngIf="f['email']?.errors?.['required']">
                                            Email is required.
                      </small>
                                            <small *ngIf="f['email']?.errors?.['pattern']">
                        Please enter valid email.
                      </small>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="col-xxl-6 col-lg-12 col-sm-6">
                                <div class="mb-md-4 mb-3 custom-form">
                                    <label for="exampleFormControlInput3" class="form-label">Phone Number</label>
                                    <div class="custom-input">
                                        <input type="tel" class="form-control" id="exampleFormControlInput3" placeholder="Enter Your Phone Number" maxlength="10" oninput="javascript: if (this.value.length > this.maxLength) this.value =
                                            this.value.slice(0, this.maxLength);">
                                        <i class="fa-solid fa-mobile-screen-button"></i>
                                    </div>
                                </div>
                            </div> -->

                            <div class="col-12">
                                <div class="mb-md-4 mb-3 custom-form">
                                    <label for="exampleFormControlTextarea" class="form-label">Message</label>
                                    <div class="custom-textarea">
                                        <textarea class="form-control" formControlName="description" id="exampleFormControlTextarea" placeholder="Enter Your Message" rows="6"></textarea>
                                        <i class="fa-solid fa-message"></i>
                                        <div *ngIf="f['description']?.invalid && (f['description']?.dirty || f['description']?.touched)" class="text-danger">
                                            <small *ngIf="f['description']?.errors?.['required']">
                                            Message is required.
                      </small>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <button class="btn btn-animation btn-md fw-bold ms-auto">Send Message</button> -->
                        <button type="submit" class="btn btn-animation btn-md fw-bold ms-auto" [disabled]="isSubmitting" (click)="contactUsUser()">
                      <span *ngIf="!isSubmitting">cuntact us</span>
                      <span *ngIf="isSubmitting"
                        class="spinner-border spinner-border-sm spinner-grow flex-shrink-0"
                        role="status" aria-hidden="true"> <p> Loading...</p></span>
                    </button>
                    </form>
                </div>

            </div>
        </div>
    </div>
</section>
<!-- Contact Box Section End -->

<!-- Map Section Start -->
<!-- <section class="map-section">
        <div class="container-fluid p-0">
            <div class="map-box">
                <iframe src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d2994.3803116994895!2d55.29773782339708!3d25.222534631321!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m5!1s0x3e5f43496ad9c645%3A0xbde66e5084295162!2sDubai%20-%20United%20Arab%20Emirates!3m2!1d25.2048493!2d55.2707828!4m0!5e1!3m2!1sen!2sin!4v1652217109535!5m2!1sen!2sin"
                    style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
        </div>
    </section> -->
<!-- Map Section End -->
